import { render, staticRenderFns } from "./AuctionType.vue?vue&type=template&id=7b35aac9&scoped=true"
import script from "./AuctionType.vue?vue&type=script&lang=js"
export * from "./AuctionType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b35aac9",
  null
  
)

export default component.exports